import React from 'react';

const SubmitPage = () => (
    <div>
        <p>Submit new venue here!</p>
    </div>
);

export default SubmitPage;